import React from 'react';
import { Paper, Typography } from '@mui/material';
import { formatDate } from 'common-date/format';
import { currencyFormat } from '../../constants';
import usePrequal from '../../resources/prequal/usePrequal';
import useApplication from '../../resources/applications/read';

const AutoPayTermsAndConditions = () => {
  const { data: prequal } = usePrequal();
  const { data: application } = useApplication();
  const {
    active_recurring_payment: activeRecurringPayment,
    primary_bank_account: primaryBankAccount,
    final_loan: finalLoan,
  } = application.attributes;
  const lastFour = primaryBankAccount?.account_number.slice(
    primaryBankAccount.account_number.length - 4,
    primaryBankAccount.account_number.length,
  );

  const accountDetails = activeRecurringPayment
    ? activeRecurringPayment.recurrable.name
    : `${primaryBankAccount?.bank_name} (${lastFour})`;

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 1,
        borderRadius: '16px',
        backgroundColor: '#FAFAFA',
        overflow: 'scroll',
        maxHeight: '300px',
      }}
    >
      <Typography variant="h3">
        Autopay Terms and Conditions
      </Typography>
      <Typography variant="caption">
        By clicking &apos;Connect your bank&apos;, you,
        {' '}
        {prequal.firstName}
        {' '}
        {prequal.lastName}
        , authorize WebBank and DigniFi, and their respective affiliates, successors, and assigns,
        to initiate monthly debits in the amount of
        {' '}
        {currencyFormat.format(finalLoan.data.attributes.payment)}
        {' '}
        from your account
        {' '}
        {accountDetails}
        . You understand that your bank account information will be saved in order to process
        recurring transactions on your account.
      </Typography>
      <Typography variant="caption">
        Recurring ACH enrollment will remain in full effect until or the earlier of
        {' '}
        {formatDate(finalLoan.data.attributes.maturity_date)}
        ,
        your account is paid off, you cancel through the customer portal, or by calling
        (855) 808-5861 or by sending notice to: DigniFi, PO Box 7084, 80306-7084.
      </Typography>
      <Typography variant="caption">
        The automatic payment authorization may be transferred to any assignee of your loan or
        any successor servicer. The payments you authorize must comply with US law. You authorize
        us to make credit and debit entries to your bank account to correct any errors
        that may occur.
      </Typography>
      <Typography variant="caption">
        In order to prevent a recurring payment, your cancellation request needs to be
        received 72 hours before your scheduled ACH debit.  By cancelling your Recurring ACH,
        you understand that you will not be relieved of your responsibility to pay all
        outstanding amounts to DigniFi.
      </Typography>
    </Paper>
  );
};

export default AutoPayTermsAndConditions;
